import React from 'react';
import {IMultiSelectProps, MultiSelectInput} from '~/components/Controls/Select';
import {FormField, hasError, IFieldProps, onChangeField} from '~/components/Form';
import {Intent} from '~/lib/intent';
import {useResource} from '~/lib/loader';
import {fetchBidderDc} from '~/modules/Bidders/api';

type ISelectDcProps = Omit<IMultiSelectProps<string>, 'items'>;

export const SelectDc = ({
    disabled,
    ...props
}: ISelectDcProps) => {
    const {resource, isPending} = useResource(() => fetchBidderDc(), []);
    return <MultiSelectInput {...props} disabled={disabled || isPending}
        rightIcon={isPending && <i className='fa fa-spinner fa-spin'/>}
        items={resource.map(dc => ({
            label: dc,
            value: dc
        }))}/>;
};

export const SelectDcField = (props: IFieldProps<ISelectDcProps>) => <FormField {...props}>
    <SelectDc {...props.options}
        intent={hasError(props) && Intent.DANGER}
        value={props.field.value} onChange={value => onChangeField(props, value)}
    />
</FormField>;
